import type { ReportHorizon } from "@eu.mdotm.api/sphere";
import type { Option } from "@mdotm/shadcn/legacy/components";
import { typedObjectValues } from "@mdotm/shadcn/legacy/utils";


const horizonMap = {
	"ONE_DAY": {
		label: "1d",
		value: "ONE_DAY",
	},
	"ONE_WEEK": {
		label: "1w",
		value: "ONE_WEEK",
	},
	"ONE_MONTH": {
		label: "1m",
		value: "ONE_MONTH",
	},
	"THREE_MONTHS": {
		label: "3m",
		value: "THREE_MONTHS",
	},
	"SIX_MONTHS": {
		label: "6m",
		value: "SIX_MONTHS",
	},
	"MONTH_TO_DATE": {
		label: "MTD",
		value: "MONTH_TO_DATE",
	},
	"QUARTER_TO_DATE": {
		label: "QTD",
		value: "QUARTER_TO_DATE",
	},
	"YEAR_TO_DATE": {
		label: "YTD",
		value: "YEAR_TO_DATE",
	},
	"ONE_YEAR": {
		label: "1y",
		value: "ONE_YEAR",
	},
	"FROM_INCEPTION": {
		label: "Since inception",
		value: "FROM_INCEPTION",
	},
} satisfies { [K in ReportHorizon]: Option<K> };

const horizonOptions = typedObjectValues(horizonMap);

export { horizonMap, horizonOptions };

